import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { ListboxModule } from 'primeng/listbox';
import { TableModule } from 'primeng/table';
import { FormgenModule } from '../../libraries/formgen/formgen.module';
import { LibrariesModule } from '../../libraries/libraries.module';
import { SharedModule } from '../../libraries/shared.module';
import { SubsidiListComponent } from './list/subsidi-list.component';
import { SubsidiRestService } from './subsidi-rest.service';
import { SubsidiRoutingModule } from './subsidi-routing.module';
import { SubsidiListSummaryComponent } from './list-summary/subsidi-list-summary.component';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SubsidiListTransactionComponent } from './list-transaction/subsidi-list-transaction.component';
import { SubsidiListVisitorsComponent } from './list-visitors/list-visitors.component';

export const PROVIDERS = [SubsidiRestService];

@NgModule({
  imports: [
    SubsidiRoutingModule,
    BsDropdownModule,
    CommonModule,
    FlexLayoutModule,
    FormgenModule,
    FormsModule,
    ListboxModule,
    LibrariesModule,
    PaginationModule,
    ReactiveFormsModule,
    RouterModule,
    SharedModule,
    TableModule,
    TranslateModule,
    DialogModule,
    ButtonModule,
    ProgressSpinnerModule
  ],
  declarations: [
    SubsidiListComponent,
    SubsidiListSummaryComponent,
    SubsidiListTransactionComponent,
    SubsidiListVisitorsComponent
  ]
})
export class SubsidiModule {}
